import api from './api'
import type { Incidente } from '@/services/lgpdService'
import type { PageResponse } from '@/types/comum'
import type {
  EstadoIncidente,
  IncidenteEvento,
  ResumoIncidentes,
  TransicaoIncidenteRequest,
} from '@/types/incidente'

const BASE = '/api/v1/lgpd/incidentes'

/**
 * Fila do DPO (Onda 7.6 / A13). Tudo aqui é ADMIN (gate do DPO no backend); o escopo por
 * tenant é decidido no servidor — tenant B nunca recebe incidente de A, com filtro ou sem.
 */
export const incidentesService = {
  fila: async (estado?: EstadoIncidente, page = 0, size = 50): Promise<PageResponse<Incidente>> => {
    const params: Record<string, string | number> = { page, size }
    if (estado) params.estado = estado
    const r = await api.get<PageResponse<Incidente>>(`${BASE}/fila`, { params })
    return r as unknown as PageResponse<Incidente>
  },

  resumo: async (): Promise<ResumoIncidentes> => {
    const r = await api.get<ResumoIncidentes>(`${BASE}/resumo`)
    return r as unknown as ResumoIncidentes
  },

  linhaDoTempo: async (protocolo: string): Promise<IncidenteEvento[]> => {
    const r = await api.get<IncidenteEvento[]>(
      `${BASE}/${encodeURIComponent(protocolo)}/linha-do-tempo`
    )
    return r as unknown as IncidenteEvento[]
  },

  /** Só para frente; para trás o servidor responde 409 (`TRANSICAO_INCIDENTE_INVALIDA`). */
  transicionar: async (
    protocolo: string,
    request: TransicaoIncidenteRequest
  ): Promise<Incidente> => {
    const r = await api.post<Incidente>(
      `${BASE}/${encodeURIComponent(protocolo)}/transicao`,
      request
    )
    return r as unknown as Incidente
  },
}
